import styled from "@emotion/styled"
import { Box, Paper } from "@mui/material"
import bgImage from "../../assets/pxfuel.jpg";

export const FlexDiv = styled('div')({
    display: "flex",
    alignItems: "center"
})

export const FlexDivColumn = styled('div')({
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "column"
})

export const FlexDivStartCenter = styled('div')({
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "row",
    alignItems: "center"
})

export const FlexDivSpace = styled('div')({
    display: "flex",
    justifyContent: "space-between"
})

export const FlexDivCenter = styled('div')({
    display: "flex",
    justifyContent: "center"
})

export const FlexDivAllCenter = styled('div')({
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
})

export const FlexDivSpaceCenter = styled('div')({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
})
export const Background = styled(Box)({
    height: '100vh',
    backgroundImage: `url(${bgImage})`, // Replace with your image URL
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
});
export const RegisterForm = styled(Paper)({
    margin: '16px',
    maxWidth: '100%',
    background: 'rgba(255, 255, 255, 0.85)',
    boxShadow: '5px'
});